import { useState } from 'react';
import LazyLoad from "react-lazyload";
import { Modal } from 'react-bootstrap';
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const VocationalClubmiddle = () => {
    const homeMenu = [
        { label: "MUN", link: "/Mun" },
        { label: "Glory to the Nation", link: "/GloryOfNation" },
        { label: "Spic Macay Cultural and Heritage Club", link: "/SpocmacyColtoralHeritage" },
        { label: "Vocational Education Clubs (Middle Wing) ", link: "/vocationalClubmiddle" },
        { label: "Vocational Education Clubs (Senior Wing)", link: "/vocationalClub" },
        { label: "Vocational Education Clubs (Primary Wing)", link: "/VocationalClubPrimary" },
    ];

    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState({ title: "", url: "" });

    const handleOpenModal = (title, url) => {
        setSelected({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const brochures = [
        { title: "HORTICULTURISTS", url: "https://online.anyflip.com/aqnsv/xfbt/index.html" },
        { title: "MASQUERADE", url: "https://online.anyflip.com/aqnsv/vkrr/index.html" },
        { title: "LOS ESPAÑOLES", url: "https://online.anyflip.com/aqnsv/wrzi/index.html" },
        { title: "LITERARY CIRCLE", url: "https://online.anyflip.com/aqnsv/jltt/index.html" },
        { title: "FITBITS", url: "https://online.anyflip.com/aqnsv/qwae/index.html" },
        { title: "GLOBAL LEADERS", url: "https://online.anyflip.com/aqnsv/zpqe/index.html" },
        { title: "LA FRANCOPHONIE", url: "https://online.anyflip.com/aqnsv/mauk/index.html" },
        { title: "DANCEPIRATION", url: "https://online.anyflip.com/aqnsv/wvuu/index.html" },
        { title: "GOURMET AND COUTURE", url: "https://online.anyflip.com/aqnsv/cklg/index.html" },
        { title: "TED CLUB", url: "https://online.anyflip.com/sdtqz/slvo/index.html" },
        { title: "SWARAAGYA CLUB", url: "https://online.anyflip.com/zpdmq/gmcy/index.html" },
        { title: "STROKES AND LETTERS", url: "https://online.anyflip.com/zpdmq/hmdb/index.html" },
        { title: "SPRACH DUO", url: "https://online.anyflip.com/zpdmq/ymaj/index.html" },
        { title: "SELF DEFENSE", url: "https://online.anyflip.com/zpdmq/rcqq/index.html" },
        { title: "RHYTHM AND FUSION", url: "https://online.anyflip.com/hjco/vlbv/index.html" },
        { title: "MICHELANGELO", url: "https://online.anyflip.com/hjco/itab/index.html" },
        { title: "MOTHER TERESA", url: "https://online.anyflip.com/hjco/xwvz/index.html" },
        { title: "MAVERICKS", url: "https://online.anyflip.com/hjco/uqze/index.html" },
        { title: "MASTERMINDS", url: "https://online.anyflip.com/hjco/hcjv/index.html" },
        { title: "ARYABHATA CLUB", url: "https://online.anyflip.com/hjco/nhhu/index.html" },
        { title: "CREATIVE POD", url: "https://online.anyflip.com/hjco/tnvn/index.html" },
        { title: "CODERS CLUB", url: "https://online.anyflip.com/hjco/djti/index.html" },
        { title: "BUDDING SCIENTISTS", url: "https://online.anyflip.com/hjco/wxpw/index.html" },
        { title: "BANKING AND FINANCE", url: "https://online.anyflip.com/hjco/xoec/index.html" },
        { title: "WRITERS ROUNDTABLE", url: "https://online.anyflip.com/sdtqz/adil/index.html" },
        { title: "WESTERN MELODIES", url: "https://online.anyflip.com/sdtqz/fudc/index.html" },
        { title: "CULTURE AND HERITAGE CLUB (SPIC MACAY)", url: "https://online.anyflip.com/aqnsv/fsmk/index.html" },
    ];

    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/blog-banner.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle
                                pageTitle="Vocational Education Clubs (Middle Wing)"
                                breadEnd="Vocational Education Clubs"
                                breadMid="Vocational Education Clubs (Middle Wing)"
                            />
                        </div>
                    </div>
                    <div className="row">
                        {brochures.map((item, index) => (
                            <div className="col-xl-3 col-md-6 col-sm-12" key={index}>
                                <div
                                    className="vocationalClub"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleOpenModal(item.title, item.url)}
                                >
                                    <LazyLoad>
                                        <img
                                            src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vocational-education-clubs.jpg"
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </LazyLoad>
                                    <p>{item.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selected.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh' }}>
                    <iframe
                        src={selected.url}
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                        title={selected.title}
                    ></iframe>
                </Modal.Body>
            </Modal>

            <Footer />
        </>
    );
};

export default VocationalClubmiddle;
